import * as React from 'react';
import { debounce } from 'framework/utils/debounce';

/**
 * Custom hook for detecting mobile screen sizes
 * @param breakpoint - The pixel width to consider as mobile (default: 767px)
 * @returns boolean indicating if the current screen width is mobile
 */
export const useMobileDetection = (breakpoint: number = 767): boolean => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = debounce(() => {
      setIsMobile(window.innerWidth <= breakpoint);
    }, 150);
    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [breakpoint]);

  return isMobile;
};
